define( function() {

	// [[Class]] -> type pairs
	return {};
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/class2type.js
 ** module id = 821
 ** module chunks = 2
 **/